// extracted by mini-css-extract-plugin
module.exports = {"holdingImage":"holding-image_holdingImage__S0BSl","icon":"holding-image_icon__4bukE"};